import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import type { TextFieldProps } from "@mui/material/TextField";
import TextField from "@mui/material/TextField";

import { PublicSvgIcon } from "~/components/public_svg_icon";

type TextInputProps = {
  clearable?: boolean;
  onClear?: () => void;
} & TextFieldProps;

export function TextInput({
  value,
  onClear,
  clearable = true,
  "data-testid": dataTestId,
  slotProps: callerSlotProps,
  ...rest
}: TextInputProps & { "data-testid"?: string }) {
  const canClear = clearable && Boolean(onClear);

  const callerInputSlot = callerSlotProps?.input as
    | (Record<string, unknown> & { inputProps?: Record<string, unknown> })
    | undefined;

  return (
    <TextField
      value={value}
      slotProps={{
        ...callerSlotProps,
        input: {
          ...(canClear
            ? {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      tabIndex={-1}
                      size="small"
                      className="clear-btn"
                      sx={{ visibility: "hidden" }}
                      onClick={onClear}
                    >
                      <PublicSvgIcon name="clear" />
                    </IconButton>
                  </InputAdornment>
                ),
              }
            : undefined),
          ...callerInputSlot,
          inputProps: {
            ...callerInputSlot?.inputProps,
            ...(dataTestId && { "data-testid": dataTestId }),
          },
        },
      }}
      sx={{
        "& .clear-btn": { visibility: "hidden" },
        "& .MuiInputBase-root:hover .clear-btn": { visibility: "visible" },
        "& .MuiInputBase-root.Mui-focused .clear-btn": {
          visibility: "visible",
        },
      }}
      {...rest}
    />
  );
}
